module.exports = "<div class=\"locations-selector-group-component\">\n    \n    <div class=\"locations-selectors\"> \n    </div>\n    \n\n</div>";